import { Box, Button, Chip, Paper, Stack, Typography, MenuItem } from "@mui/material";
import { DataGrid, getGridStringOperators } from "@mui/x-data-grid";
import { useEffect, useState, useContext, useCallback } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { useNavigate } from "react-router-dom";
import DeletePoll from "./DeletePoll";
import { sundayPollApi } from "../../store/sundayPolls/sundayPollsList";
import { resetSundayPoll } from "../../store/sundayPolls/sundayPollDetail";
import moment from "moment";
import { ThemeContext } from '../../context/ThemeContext';
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import PublishUnpublishModule from "../../components/PublishUnpublishModule";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import DataGridComponent from "../../components/DataGridComponent";
import PermissionGate from "../../components/PermissionGate";

export default function ManagePoll() {
  const sundayPollList = useSelector((state) => state?.sundayPollList);
  const { result, order_category, loading, total } = sundayPollList;
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDownload, setIsDownload] = useState(false)

  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [queryOptions, setQueryOptions] = useState({});
  const [publishModel, setPublishModel] = useState(false);

  const getSundayPollList = useCallback((queryOptions, paginationModel) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(sundayPollApi(query));
  }, [dispatch])

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "Poll Id",
      filterable: false,
      sortable: false,
      width: 80,
    },
    {
      field: "title",
      headerName: "Title",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 150,
    },
    {
      field: "poll_publish_datatime",
      headerName: "Date",
      filterable: false,
      sortable: false,
      renderCell: (row) => (
        <>
          {
            <>
              {moment(row.row.poll_publish_datatime).format('DD-MM-YYYY')}
            </>
          }
        </>
      ),
      width: 100,
    },
    {
      field: "poll_question",
      headerName: "Question",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },
    {
      field: "image",
      headerName: "Poll Image",
      filterable: false,
      sortable: false,
      width: 250,
      renderCell: (params) => (
        <Box sx={{ py: 1 }}><img width={200} height={100} src={params.row.poll_pic} alt='banner image' /></Box>)
    },
    {
      headerName: "Action",
      filterable: false,
      sortable: false,
      width: 250,
      disableExport: true,
      renderCell: (row) => (
        <>
          {
            <>
              <PermissionGate module="polls" action="update">
                <Button color="success" label="Available" variant="outlined"
                  onClick={() => navigate(`/edit-sunday-poll/${row.id}`)}
                >
                  Edit
                </Button>
              </PermissionGate>
              <PermissionGate module="polls" action="delete">
                <Button
                  color="success"
                  label="Available"
                  variant="outlined"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    setNotSelectedProductModel(true)
                    setDeleteId(row.id)
                  }}
                >
                  Delete
                </Button>
              </PermissionGate>
              <PermissionGate module="polls" action="read">
                <Button style={{ marginLeft: "5px" }} color="success" label="Available" variant="outlined"
                  onClick={() => navigate(`/results/${row.id}`)}
                >
                  Results
                </Button>
              </PermissionGate>
            </>
          }
        </>
      ),
    },
    {
      field: "publish",
      headerName: "Publish Sunday Poll",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="polls" action={row.row.published ? "unpublish" : "publish"}>
            <Button
              color="info"
              onClick={() => {
                setPublishModel(true)
                setDeleteId(row.id)
                setSelectedRow(row.row)
              }}
              endIcon={<ArrowRightAltIcon />}>
              {row.row.published ? "Unpublish" : "Publish"}
            </Button>
          </PermissionGate>
        </>
      ),
    },
  ];

  const addToCartHandler = async () => {

    navigate("/add-sunday-poll");

  };

  useEffect(() => {
    getSundayPollList(queryOptions, paginationModel)
    dispatch(resetSundayPoll());
  }, [dispatch, paginationModel, queryOptions, getSundayPollList]);
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Polls List</Typography>
        </Stack>
        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>

            <PermissionGate module="polls" action="create">
              <Button
                onClick={addToCartHandler}
                variant="contained"
              >
                Create New Poll
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>

        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
                    height: 500 
                }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "pollList", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, permissionModule: "polls", apiUrl: apiRoutes.sundayPollsAction(`poll-list`, 0) })),
            }}
            slotProps={{
loadingOverlay: {
      variant: 'linear-progress',
      noRowsVariant: 'linear-progress',
    },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>
      </Body>

      <DeletePoll
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        id={deleteId}
      />
      <BackdropUI open={isDownload} />
      <PublishUnpublishModule
        open={publishModel}
        setOpen={setPublishModel}
        selectedRow={selectedRow}
        queryOptions={queryOptions}
        paginationModel={paginationModel}
        moduleType={"sunday_polls"}
        moduleList={getSundayPollList}
      />
    </>
  );
}
